
export default class Utitl{
	static getUrlKey(name,url){
		var search = name + "=";
		var index = url.indexOf(search);
		var length =url.length - index;
		var start = index+search.length;
		var value = url.substring(start);
		var items = value.split("&");
		var value = items[0];
		
		return value;
	}
}